import { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { applyUpdate, isUpdateAvailable, subscribeToUpdates } from "util/pwaUpdates";
import "./PwaUpdateNotice.css";

export default function PwaUpdateNotice() {
  const [available, setAvailable] = useState(isUpdateAvailable);
  const [modal, contextHolder] = Modal.useModal();
  useEffect(() => {
    const refresh = () => setAvailable(isUpdateAvailable());
    const unsubscribe = subscribeToUpdates(refresh);
    refresh();
    return unsubscribe;
  }, []);

  if (!available) return contextHolder;
  return <>
    {contextHolder}
    <div className="pwa-update-notice" role="status">
      <div className="pwa-update-notice-inner">
        <strong className="pwa-update-notice-copy">Versiune nouă disponibilă</strong>
        <Button type="primary" size="small" onClick={() => modal.confirm({
          title: "Actualizezi aplicația?",
          icon: null,
          width: 320,
          centered: true,
          okText: "Actualizează", cancelText: "Mai târziu",
          onOk: () => applyUpdate().catch((error) => {
            modal.error({ title: "Actualizarea nu a reușit", content: error.message });
            throw error;
          }),
        })}>Actualizează</Button>
      </div>
    </div>
  </>;
}
